import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useRequest } from 'hooks/useRequest'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import DefaultSelect from 'components/formElements/DefaultSelect'
import Spinner from 'components/loader/Spinner'
import { Dropdown } from 'primereact/dropdown'
import { InputTextarea } from 'primereact/inputtextarea'
import { InputNumber } from 'primereact/inputnumber'
import { currencyTypes, leadManagementDocumentType, leadManagementDocumentTypeList, leadManagementProjectDurationTypeList, leadManagementStatus, leadManagementStatusList, slaTypes } from 'utils/Constants'
import Button from 'components/formElements/Button'
import { Calendar } from 'primereact/calendar'
import moment from 'moment/moment'
import useToast from 'hooks/useToast'
import { getPermission } from 'utils/Auth'
import { Dialog } from 'primereact/dialog'
import ApprovalContent from 'components/modalContent/ApprovalContent'
import { useDispatch, useSelector } from 'react-redux'
import { closeApprovalModal, openApprovalModal } from 'redux/features/general/generalSlice'
import AccordionComp from 'components/accordion/Accordion'
import { DataTable } from 'primereact/datatable'
import Icons from 'assets/icons'
import { Column } from 'primereact/column'
import LeadManagementDocumentModalContent from 'components/modalContent/LeadManagementDocumentModalContent'
import LeadManagementEventModalContent from 'components/modalContent/LeadManagementEventModalContent'
import LeadManagementContactModalContent from 'components/modalContent/LeadManagementContactModalContent'
import { Checkbox } from 'primereact/checkbox'

const LeadManagementDetail = () => {
    const { leadManagementId } = useParams()
    const [request] = useRequest()
    const { showToast } = useToast()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { general } = useSelector((state) => state)
    const { approvalModal } = general
    const [leadManagement, setLeadManagement] = useState()
    const [leadManagementTitle, setLeadManagementTitle] = useState()
    const [technologies, setTechnologies] = useState([])
    const [customers, setCustomers] = useState([])
    const [accountManagers, setAccountManagers] = useState([])
    const [pmos, setPmos] = useState([])
    const [rejectReasons, setRejectReasons] = useState([])
    const [leadManagementDocuments, setLeadManagementDocuments] = useState([])
    const [upsertLeadManagementDocument, setUpsertLeadManagementDocument] = useState({ open: false, id: null })
    const [leadManagementEvents, setLeadManagementEvents] = useState([])
    const [filteredLeadManagementEvents, setFilteredLeadManagementEvents] = useState([])
    const [leadManagementEventsFilterOptions, setLeadManagementEventsFilterOptions] = useState({ isSystemGenerated: false })
    const [upsertLeadManagementEventModal, setUpsertLeadManagementEventModal] = useState({ open: false, id: null })
    const [leadManagementContacts, setLeadManagementContacts] = useState([])
    const [upsertLeadManagementContactModal, setUpsertLeadManagementContactModal] = useState({ open: false, id: null })

    useEffect(() => {
        getLeadManagement()
        getLeadManagementDocuments()
        getLeadManagementEvents()
        getLeadManagementContacts()
    }, [leadManagementId])

    const getLeadManagement = () => {
        request('/LeadManagement/GetLeadManagementById', { method: 'GET', params: { id: leadManagementId } })
            .then(res => {
                if (res.data.ok) {
                    setLeadManagement(res.data.result)
                    setLeadManagementTitle(`${res.data.result.leadManagementCustomerName} - ${res.data.result.projectName}`)
                } else {
                    showToast('Proje Bulunamadı', 'error')
                    navigate('/lead-management')
                }
            })

        request('/LeadManagement/GetLeadManagementCustomers', { method: 'GET' }).then((res) => {
            if (res.data.ok) {
                setCustomers(res.data.result.map((c) => ({ label: c.name, value: c.id })))
            }
        })
    }

    useEffect(() => {
        request('/Account/GetAllUsers', { method: 'GET' }).then((res) => {
            if (res.data.ok) {
                setAccountManagers(res.data.result.filter((u) => u.roles?.find((r) => r.name === 'AccountManager'))
                    .map((u) => ({ label: `${u.firstName} ${u.lastName}`, value: u.id })))
                setPmos(res.data.result.filter((u) => u.roles?.every((r) => r.name === 'Administrator'))
                    .map((u) => ({ label: `${u.firstName} ${u.lastName}`, value: u.id })))
            }
        })

        request('/Technologies/GetAllTechnologies', { method: 'GET' }).then((res) => {
            if (res.data.ok) {
                setTechnologies(res.data.result.map((t) => ({ label: t.name, value: t.id })))
            }
        })

        request('/LeadManagement/GetLeadManagementRejectReasons', { method: 'GET' }).then((res) => {
            if (res.data.ok) {
                setRejectReasons(res.data.result.map((c) => ({ label: c.name, value: c.id })))
            }
        })
    }, [])

    useEffect(() => {
        let filtered = leadManagementEvents.filter((l) => {
            let result = true

            result &&= l.isSystemGenerated === leadManagementEventsFilterOptions.isSystemGenerated

            return result
        })

        setFilteredLeadManagementEvents(filtered)
    }, [leadManagementEventsFilterOptions, leadManagementEvents])

    const handleChange = (e, name) => {
        if (name) {
            setLeadManagement((prev) => ({ ...prev, [name]: e }))
        } else {
            setLeadManagement((prev) => ({ ...prev, [e.target.name]: e.target.value }))
        }
    }

    const handleSave = () => {
        if (!leadManagement?.leadManagementCustomerId && !leadManagement?.newCustomerName) {
            showToast('Müşteri Adını Girin', 'error')
            return
        }

        if (!leadManagement?.projectName) {
            showToast('Proje Adını Girin', 'error')
            return
        }

        if (!leadManagement?.leadManagementTechnologies?.length) {
            showToast('Teknoloji Seçin', 'error')
            return
        }

        if (!leadManagement?.accountManagerUserId) {
            showToast('Account Manager Seçin', 'error')
            return
        }

        if (!leadManagement?.responsibleAdminUserId) {
            showToast('Sorumlu PMO Seçin', 'error')
            return
        }

        leadManagement.projectBudgetCurrency = leadManagement.projectBudget ? leadManagement.projectBudgetCurrency || currencyTypes[0].value : null
        leadManagement.slaBudgetCurrency = leadManagement.slaBudget ? leadManagement.slaBudgetCurrency || currencyTypes[0].value : null
        leadManagement.mdPriceCurrency = leadManagement.mdPrice ? leadManagement.mdPriceCurrency || currencyTypes[0].value : null
        leadManagement.rejectReasonId = leadManagement.status === leadManagementStatus.rejected.value ? leadManagement.rejectReasonId : null
        leadManagement.projectDurationType = leadManagement.projectDuration ? leadManagement.projectDurationType || leadManagementProjectDurationTypeList[0].value : null

        request('/LeadManagement/UpsertLeadManagement', {
            method: 'POST',
            data: leadManagement
        }).then((res) => {
            if (res.data.ok) {
                showToast('Proje Kaydedildi', 'success')
                getLeadManagement()
                getLeadManagementEvents()
            }
        })
    }

    const handleDelete = () => {
        dispatch(openApprovalModal({ open: true, content: 'Projeyi silmek istediğinize emin misiniz?', requestType: 'delete' }))
    }

    const handleArchive = () => {
        dispatch(
            openApprovalModal({
                open: true,
                content: leadManagement.isArchived
                    ? 'Projeyi arşivden çıkarmak istediğinize emin misiniz?'
                    : 'Projeyi arşivlemek istediğinize emin misiniz?',
                requestType: 'archive'
            })
        )
    }

    const handleApprovalModalApproved = () => {
        if (approvalModal.requestType === 'delete') {
            request('/LeadManagement/DeleteLeadManagement', { method: 'DELETE', data: { id: leadManagementId } }).then((res) => {
                if (res.data.ok) {
                    handleCloseApprovalModal()
                    showToast('Proje Silindi', 'success')
                    navigate('/lead-management')
                }
            })
            return
        }

        if (approvalModal.requestType === 'archive') {
            request('/LeadManagement/ArchiveLeadManagement', { method: 'POST', data: { id: leadManagementId } }).then((res) => {
                if (res.data.ok) {
                    handleCloseApprovalModal()
                    showToast(leadManagement.isArchived ? 'Proje Arşivden Çıkarıldı' : 'Proje Arşivlendi', 'success')
                    getLeadManagement()
                }
            })
            return
        }

        if (approvalModal.deleteEndpoint) {
            request(approvalModal.deleteEndpoint, { method: 'DELETE', data: { id: approvalModal.deleteData.id } }).then((res) => {
                handleCloseApprovalModal()
                if (res.data.ok) {
                    showToast('Silme İşlemi Başarılı', 'success')
                    switch (approvalModal.tableForDelete) {
                        case 'documents':
                            getLeadManagementDocuments()
                            break
                        case 'events':
                            getLeadManagementEvents()
                            break
                        case 'contacts':
                            getLeadManagementContacts()
                            break
                    }
                } else {
                    showToast(res.data?.metadata?.message || 'Silme İşleminde bir hata oluştu', 'error')
                }
            })
        }
    }

    const handleCloseApprovalModal = () => {
        dispatch(closeApprovalModal())
    }

    const deleteButton = (deleteData, deleteEndpoint, tableForDelete) => {
        return (
            <Icons.deleteNotFill
                onClick={() => {
                    handleDeleteRow(deleteData, deleteEndpoint, tableForDelete)
                }}
                size={20}
                className='text-danger cursor-pointer'
            />
        )
    }

    const handleDeleteRow = (deleteData, deleteEndpoint, tableForDelete) => {
        dispatch(openApprovalModal({ open: true, content: 'Silmek istedğinize emin misiniz?', deleteData, deleteEndpoint, tableForDelete }))
    }

    const getLeadManagementDocuments = () => {
        request('/LeadManagement/GetLeadManagementDocuments', { method: 'GET', params: { leadManagementId } }).then((res) => {
            if (res.data.ok) {
                setLeadManagementDocuments(res.data.result)
            }
        })
    }

    const getLeadManagementEvents = () => {
        request('/LeadManagement/GetLeadManagementEvents', { method: 'GET', params: { leadManagementId } }).then((res) => {
            if (res.data.ok) {
                setLeadManagementEvents(res.data.result)
            }
        })
    }

    const getLeadManagementContacts = () => {
        request('/LeadManagement/GetLeadManagementContacts', { method: 'GET', params: { leadManagementId } }).then((res) => {
            if (res.data.ok) {
                setLeadManagementContacts(res.data.result)
            }
        })
    }

    return (
        <AnimatedSpan className='page-container d-flex flex-column gap-4'>
            {leadManagementTitle && (
                <div style={{ position: 'relative', width: '100%', top: '-16px', marginBottom: '50px' }}>
                    <div className='card' style={{ position: 'fixed', width: '100%', zIndex: 1, left: 0, borderRadius: 0 }}>
                        <div className='d-flex justify-content-between gap-3'>
                            <div className='row flex-1'>
                                <div className='col-md-6'>
                                    <h1 className='heading-1 text-bold'>{leadManagementTitle}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className='card'>
                {!leadManagement && <div className='row text-center'>
                    <div className='col-md-12'>
                        <Spinner size={3} />
                    </div>
                </div>}
                {leadManagement && <>
                    <div className='row'>
                        <div className='col-md-10 col-lg-11 col-xl-11'>
                            <div className='row-margin-x'>
                                <div className='col-lg-8 col-md-6'>
                                    <div className='row-margin-x'>
                                        <div className='col-lg-6'>
                                            <div className='form-control'>
                                                <label className='form-control-label'>Müşteri Adı</label>
                                                <Dropdown value={leadManagement?.leadManagementCustomerId || leadManagement?.newCustomerName}
                                                          onChange={e => {
                                                              if (!e.originalEvent) return
                                                              let isId = Number.isInteger(e.value) && customers.find(c => c.value === e.value)
                                                              setLeadManagement((prev) => ({
                                                                  ...prev,
                                                                  leadManagementCustomerId: isId ? e.value : null,
                                                                  newCustomerName: isId ? null : e.value
                                                              }))
                                                          }}
                                                          onInput={e => {
                                                              setLeadManagement((prev) => ({ ...prev, leadManagementCustomerId: null, newCustomerName: e.target.value }))
                                                          }}
                                                          options={customers}
                                                          optionLabel='label'
                                                          optionValue='value'
                                                          filter
                                                          filterLocale='tr'
                                                          editable
                                                          filterInputAutoFocus={false}
                                                          className={'w-100'} />
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className='form-control'>
                                                <label className='form-control-label'>Proje Adı</label>
                                                <input
                                                    className='default-input'
                                                    type='text'
                                                    name='projectName'
                                                    onChange={handleChange}
                                                    value={leadManagement.projectName}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row-margin-x mt-3'>
                                        <div className='col-lg-6'>
                                            <div className='form-control'>
                                                <div className='form-control-label'>Teknolojiler</div>
                                                <DefaultSelect
                                                    isMulti
                                                    handleChange={(e) => handleChange(e.map((t) => ({ technologyId: t.value })), 'leadManagementTechnologies')}
                                                    selectOptions={technologies}
                                                    value={leadManagement.leadManagementTechnologies?.map((t) => technologies.find((tt) => tt.value === t.technologyId))}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className='row-margin-x'>
                                                <div className='col-lg-6'>
                                                    <div className='form-control'>
                                                        <div className='form-control-label'>Hedeflenen Teklif Tarihi</div>
                                                        <Calendar
                                                            className={'w-100'}
                                                            dateFormat='dd/mm/yy'
                                                            name='offerDate'
                                                            onChange={(e) => {
                                                                handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
                                                            }}
                                                            value={leadManagement.offerDate && moment(leadManagement.offerDate).locale('en')._d}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-lg-6'>
                                                    <div className='form-control'>
                                                        <div className='form-control-label'>Hatırlatma Tarihi</div>
                                                        <Calendar
                                                            className={'w-100'}
                                                            dateFormat='dd/mm/yy'
                                                            name='reminderDate'
                                                            onChange={(e) => {
                                                                handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
                                                            }}
                                                            value={leadManagement.reminderDate && moment(leadManagement.reminderDate).locale('en')._d}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row-margin-x mt-3'>
                                        <div className='col-lg-6'>
                                            <div className='form-control'>
                                                <label className='form-control-label'>Account Manager</label>
                                                <DefaultSelect
                                                    handleChange={(e) => handleChange(e.value, 'accountManagerUserId')}
                                                    selectOptions={accountManagers}
                                                    value={accountManagers.find((am) => am.value === leadManagement.accountManagerUserId)}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className='form-control'>
                                                <div className='form-control-label'>Sorumlu PMO</div>
                                                <DefaultSelect
                                                    handleChange={(e) => handleChange(e.value, 'responsibleAdminUserId')}
                                                    selectOptions={pmos}
                                                    value={pmos.find((p) => p.value === leadManagement.responsibleAdminUserId)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row-margin-x mt-3'>
                                        <div className='col-lg-4'>
                                            <div className='form-control'>
                                                <label className='form-control-label'>Proje Bütçesi</label>
                                                <div className='p-inputgroup'>
                                                    <InputNumber
                                                        mode='decimal'
                                                        maxFractionDigits={2}
                                                        minFractionDigits={2}
                                                        className={'flex-fill w-100'}
                                                        value={leadManagement.projectBudget}
                                                        onChange={(e) => handleChange(e.value, 'projectBudget')}
                                                    />
                                                    <Dropdown
                                                        value={leadManagement.projectBudgetCurrency || currencyTypes[0].value}
                                                        className={'w-auto'}
                                                        onChange={(e) => handleChange(e.value, 'projectBudgetCurrency')}
                                                        options={currencyTypes}
                                                        optionLabel='label'
                                                        optionValue='value'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4'>
                                            <div className='form-control'>
                                                <label className='form-control-label'>SLA Bütçesi</label>
                                                <div className='p-inputgroup'>
                                                    <InputNumber
                                                        mode='decimal'
                                                        maxFractionDigits={2}
                                                        minFractionDigits={2}
                                                        className={'flex-fill w-100'}
                                                        value={leadManagement.slaBudget}
                                                        onChange={(e) => handleChange(e.value, 'slaBudget')}
                                                    />
                                                    <Dropdown
                                                        value={leadManagement.slaBudgetCurrency || currencyTypes[0].value}
                                                        className={'w-auto'}
                                                        onChange={(e) => handleChange(e.value, 'slaBudgetCurrency')}
                                                        options={currencyTypes}
                                                        optionLabel='label'
                                                        optionValue='value'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4'>
                                            <div className='form-control'>
                                                <label className='form-control-label'>M/D Fiyatı</label>
                                                <div className='p-inputgroup'>
                                                    <InputNumber
                                                        mode='decimal'
                                                        maxFractionDigits={2}
                                                        minFractionDigits={2}
                                                        className={'flex-fill w-100'}
                                                        value={leadManagement.mdPrice}
                                                        onChange={(e) => handleChange(e.value, 'mdPrice')}
                                                    />
                                                    <Dropdown
                                                        value={leadManagement.mdPriceCurrency || currencyTypes[0].value}
                                                        className={'w-auto'}
                                                        onChange={(e) => handleChange(e.value, 'mdPriceCurrency')}
                                                        options={currencyTypes}
                                                        optionLabel='label'
                                                        optionValue='value'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row-margin-x mt-3'>
                                        <div className='col-lg-4'>
                                            <div className='form-control'>
                                                <div className='form-control-label'>Proje Süresi</div>
                                                <div className='p-inputgroup'>
                                                    <InputNumber
                                                        mode={'decimal'}
                                                        maxFractionDigits={2}
                                                        minFractionDigits={0}
                                                        min={0}
                                                        className={'flex-fill w-100'}
                                                        value={leadManagement.projectDuration}
                                                        onChange={(e) => handleChange(e.value, 'projectDuration')}
                                                    />
                                                    <Dropdown
                                                        value={leadManagement?.projectDurationType || leadManagementProjectDurationTypeList[0].value}
                                                        className={'w-auto'}
                                                        onChange={(e) => handleChange(e.value, 'projectDurationType')}
                                                        options={leadManagementProjectDurationTypeList}
                                                        optionLabel='label'
                                                        optionValue='value'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4'>
                                            <div className='form-control'>
                                                <label className='form-control-label'>SLA Tipi</label>
                                                <div className='p-inputgroup'>
                                                    <DefaultSelect
                                                        handleChange={(e) => handleChange(e.map((s) => s.value).join(';'), 'slaType')}
                                                        value={leadManagement.slaType?.split(';').map((s) => slaTypes.find((st) => st.value === s))}
                                                        selectOptions={slaTypes}
                                                        isMulti
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4'>
                                            <div className='form-control'>
                                                <div className='form-control-label'>Hot İşler</div>
                                                <DefaultSelect
                                                    handleChange={(e) => handleChange(e.value, 'isFeatured')}
                                                    placeholder='Hot İşler'
                                                    value={[
                                                        { label: 'Evet', value: true },
                                                        { label: 'Hayır', value: false }
                                                    ].find((f) => f.value === leadManagement.isFeatured)}
                                                    selectOptions={[
                                                        { label: 'Evet', value: true },
                                                        { label: 'Hayır', value: false }
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-6'>
                                    <div className='form-control'>
                                        <div className='form-control-label'>Durum</div>
                                        <Dropdown
                                            value={leadManagement.status}
                                            onChange={(e) => handleChange(e.value, 'status')}
                                            options={leadManagementStatusList}
                                            optionLabel='label'
                                            optionValue='value'
                                            className={'w-100'}
                                        />
                                    </div>

                                    {leadManagement.status === leadManagementStatus.rejected.value && (
                                        <div className='form-control mt-3'>
                                            <div className='form-control-label'>Reddedilme Nedeni</div>
                                            <Dropdown
                                                value={leadManagement.rejectReasonId}
                                                onChange={(e) => handleChange(e.value, 'rejectReasonId')}
                                                options={rejectReasons}
                                                optionLabel='label'
                                                optionValue='value'
                                                className={'w-100 p-overflow-hidden'}
                                                showClear
                                            />
                                        </div>
                                    )}

                                    <div className='form-control mt-3'>
                                        <div className='form-control-label'>Proje Özeti</div>
                                        <InputTextarea
                                            className={'w-100'}
                                            name='projectDescription'
                                            onChange={handleChange}
                                            autoResize={false}
                                            style={{ width: '100%', height: '227px' }}
                                            value={leadManagement.projectDescription}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-2 col-lg-1 col-xl-1 d-flex px-md-0 flex-column align-items-end'>
                            <Button title='Kaydet' handleClick={handleSave} className='btn-success w-100 d-flex justify-content-center mt-4' />
                            {getPermission('LeadManagement.delete') && <Button title='Projeyi Sil' handleClick={handleDelete} className='btn-danger w-100 d-flex justify-content-center mt-3' />}
                            {getPermission('LeadManagement.delete') && <Button title={leadManagement.isArchived ? 'Arşivden Çıkar' : 'Arşivle'} handleClick={handleArchive} className='btn-primary w-100 d-flex justify-content-center mt-3' />}
                        </div>
                    </div>
                </>
                }
            </div>

            <AccordionComp title='Dokümanlar' onTabOpen={getLeadManagementDocuments} className='mt-3'>
                <div className='row-margin-x'>
                    <div className='col-md-12'>
                        <DataTable
                            emptyMessage='Hiç Kayıt Bulunamadı'
                            responsiveLayout='stack'
                            dataKey='id'
                            header={
                                <div className='d-flex justify-content-end'>
                                    {getPermission('LeadManagement.update') && <Button className='btn-primary btn-sm' title='Doküman Ekle' handleClick={() => setUpsertLeadManagementDocument({ open: true, id: null })} icon={<Icons.plus />} />}
                                </div>
                            }
                            paginator
                            alwaysShowPaginator={false}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Toplam {totalRecords} kayıttan {first} - {last} arasındakiler gösteriliyor"
                            rows={10}
                            value={leadManagementDocuments}
                            rowClassName={`cursor-pointer table-hover`}
                            cellClassName={`text-sm p-2`}
                        >
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='type'
                                style={{ width: 'auto' }}
                                header='Doküman Tipi'
                                sortable
                                body={(rowData) => `${leadManagementDocumentTypeList.find(t => t.value === rowData.type)?.label}${rowData.type === leadManagementDocumentType.other.value && rowData.customType ? ` - ${rowData.customType}` : ''}`}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='version'
                                style={{ width: '9rem' }}
                                header='Versiyon'
                                sortable
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='createdAt'
                                style={{ width: '13rem' }}
                                header='Eklenme Tarihi'
                                sortable
                                sortFunction={e => (e.data.sort((a, b) => {
                                    let dateA = new Date(a.updatedAt || a.createdAt)
                                    let dateB = new Date(b.updatedAt || b.createdAt)
                                    return e.order * (dateA > dateB ? 1 : -1)
                                }))}
                                body={(rowData) => ((rowData.updatedAt && moment(rowData.updatedAt)._d.toLocaleString('tr-TR')) || (rowData.createdAt && moment(rowData.createdAt)._d.toLocaleString('tr-TR')))}
                            />
                            <Column
                                className='text-semi-bold text-sm'
                                header='Doküman'
                                headerClassName='text-bold bg-primary text-default'
                                style={{ width: 'auto' }}
                                body={(rowData) => (
                                    <a download={rowData.fileName}
                                       href={`data:${rowData.contentType};base64,${rowData.data}`}
                                       className='text-primary text-underlined cursor-pointer mr-2'>
                                        {rowData.fileName}
                                    </a>
                                )}
                            />
                            <Column
                                field='action'
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold pl-0'
                                style={{ width: '2.5rem' }}
                                body={(rowData) => (
                                    <span className='d-flex gap-1'>
                                        {getPermission('LeadManagement.update') && deleteButton(rowData, '/LeadManagement/DeleteLeadManagementDocument', 'documents')}
                                    </span>
                                )}
                            />
                        </DataTable>
                    </div>
                </div>
            </AccordionComp>

            <AccordionComp title='Etkinlikler' onTabOpen={getLeadManagementEvents} className='mt-3'>
                <div className='row-margin-x'>
                    <div className='col-md-12'>
                        <DataTable
                            emptyMessage='Hiç Kayıt Bulunamadı'
                            responsiveLayout='stack'
                            dataKey='id'
                            header={
                                <div className='d-flex justify-content-between align-items-center gap-3'>
                                    <div className='d-flex gap-3'>
                                        <div className='form-control flex-row gap-2'>
                                            <Checkbox inputId='isSystemGenerated' checked={leadManagementEventsFilterOptions.isSystemGenerated} onChange={() => setLeadManagementEventsFilterOptions((prev) => ({ ...prev, isSystemGenerated: !prev.isSystemGenerated }))} />
                                            <label htmlFor='isSystemGenerated' className='form-control-label'>Logları Göster</label>
                                        </div>
                                    </div>

                                    <div className='d-flex justify-content-end'>
                                        {getPermission('LeadManagement.update') && <Button className='btn-primary btn-sm' title='Etkinlik Ekle' handleClick={() => setUpsertLeadManagementEventModal({ open: true, id: null })} icon={<Icons.plus />} />}
                                    </div>
                                </div>
                            }
                            paginator
                            alwaysShowPaginator={false}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Toplam {totalRecords} kayıttan {first} - {last} arasındakiler gösteriliyor"
                            rows={10}
                            value={filteredLeadManagementEvents}
                            rowClassName={`cursor-pointer table-hover`}
                            cellClassName={`text-sm p-2`}
                            onRowClick={e => {
                                if (e.originalEvent.target.className.includes('p-button-icon')) return
                                if (getPermission('LeadManagement.update') && e.data.id) {
                                    setUpsertLeadManagementEventModal({ open: true, id: e.data.id })
                                }
                            }}
                        >
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='leadManagementEventTypeName'
                                style={{ width: 'auto' }}
                                header='Etkinlik Tipi'
                                sortable
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='eventDate'
                                style={{ width: '12rem' }}
                                header='Etkinlik Tarihi'
                                sortable
                                body={(rowData) => rowData.eventDate && moment(rowData.eventDate)._d.toLocaleString('tr-TR')}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                field='description'
                                style={{ width: '500px', maxWidth: '100%' }}
                                header='Etkinlik Notu'
                                sortable
                                body={(rowData) => rowData.description && (
                                    <span className='scroll-note' style={{ maxWidth: '100%', padding: '5px', maxHeight: '100px', overflowY: 'auto', display: 'flex', margin: '0' }}>
                                        {rowData.description}
                                    </span>
                                )}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                field='createdBy'
                                style={{ width: 'auto' }}
                                header='Oluşturan Kişi'
                            />
                            <Column
                                className='text-semi-bold text-sm'
                                field='attachment'
                                header='Ek'
                                headerClassName='text-bold bg-primary text-default'
                                sortable='true'
                                style={{ width: 'auto' }}
                                body={(rowData) => rowData.attachmentData && (
                                    <a download={rowData.attachmentFileName}
                                       href={`data:${rowData.attachmentContentType};base64,${rowData.attachmentData}`}
                                       className='text-primary text-underlined cursor-pointer mr-2'>
                                        {rowData.attachmentFileName}
                                    </a>
                                )}
                            />
                            <Column
                                field='action'
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold pl-0'
                                style={{ width: '2.5rem' }}
                                body={(rowData) => (
                                    <span className='d-flex gap-1'>
                                        {getPermission('LeadManagement.update') && deleteButton(rowData, '/LeadManagement/DeleteLeadManagementEvent', 'events')}
                                    </span>
                                )}
                            />
                        </DataTable>
                    </div>
                </div>
            </AccordionComp>

            <AccordionComp title='Kişiler' onTabOpen={getLeadManagementContacts} className='mt-3'>
                <div className='row-margin-x'>
                    <div className='col-md-12'>
                        <DataTable
                            emptyMessage='Hiç Kayıt Bulunamadı'
                            responsiveLayout='stack'
                            dataKey='id'
                            header={
                                <div className='d-flex justify-content-end'>
                                    {getPermission('LeadManagement.update') && <Button className='btn-primary btn-sm' title='Kişi Ekle' handleClick={() => setUpsertLeadManagementContactModal({ open: true, id: null })} icon={<Icons.plus />} />}
                                </div>
                            }
                            paginator
                            alwaysShowPaginator={false}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Toplam {totalRecords} kayıttan {first} - {last} arasındakiler gösteriliyor"
                            rows={10}
                            value={leadManagementContacts}
                            rowClassName={`cursor-pointer table-hover`}
                            cellClassName={`text-sm p-2`}
                            onRowClick={e => {
                                if (e.originalEvent.target.className.includes('p-button-icon')) return
                                if (getPermission('LeadManagement.update') && e.data.id) {
                                    setUpsertLeadManagementContactModal({ open: true, id: e.data.id })
                                }
                            }}
                        >
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='firstName'
                                style={{ width: 'auto' }}
                                header='Kişi Adı'
                                sortable
                                body={(rowData) => `${rowData.firstName} ${rowData.lastName}`}
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='email'
                                style={{ width: 'auto' }}
                                header='E-Posta'
                                sortable
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='phone'
                                style={{ width: 'auto' }}
                                header='Telefon'
                                sortable
                            />
                            <Column
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold'
                                field='role'
                                style={{ width: 'auto' }}
                                header='Rol'
                                sortable
                            />
                            <Column
                                field='action'
                                headerClassName='text-bold bg-primary text-default'
                                className='text-semi-bold pl-0'
                                style={{ width: '2.5rem' }}
                                body={(rowData) => (
                                    <span className='d-flex gap-1'>
                                        {getPermission('LeadManagement.update') && deleteButton(rowData, '/LeadManagement/DeleteLeadManagementContact', 'contacts')}
                                    </span>
                                )}
                            />
                        </DataTable>
                    </div>
                </div>
            </AccordionComp>

            <Dialog draggable={false} visible={approvalModal.open} onHide={handleCloseApprovalModal}>
                <ApprovalContent handleClose={handleCloseApprovalModal} handleApproved={handleApprovalModalApproved} />
            </Dialog>
            <Dialog style={{ width: '500px', maxWidth: '100%' }} draggable={false} header={upsertLeadManagementDocument.id ? 'Doküman Düzenle' : 'Doküman Ekle'} visible={upsertLeadManagementDocument.open} onHide={() => setUpsertLeadManagementDocument({ open: false, id: null })}>
                <LeadManagementDocumentModalContent handleClose={() => setUpsertLeadManagementDocument({ open: false, id: null })} handleAdd={getLeadManagementDocuments} entityId={upsertLeadManagementDocument.id} />
            </Dialog>
            <Dialog style={{ width: '500px', maxWidth: '100%' }} draggable={false} header={upsertLeadManagementEventModal.id ? 'Etkinlik Düzenle' : 'Etkinlik Ekle'} visible={upsertLeadManagementEventModal.open} onHide={() => setUpsertLeadManagementEventModal({ open: false, id: null })}>
                <LeadManagementEventModalContent handleClose={() => setUpsertLeadManagementEventModal({ open: false, id: null })} handleAdd={getLeadManagementEvents} entityId={upsertLeadManagementEventModal.id} />
            </Dialog>
            <Dialog style={{ width: '500px', maxWidth: '100%' }} draggable={false} header={upsertLeadManagementContactModal.id ? 'Kişi Düzenle' : 'Kişi Ekle'} visible={upsertLeadManagementContactModal.open} onHide={() => setUpsertLeadManagementContactModal({ open: false, id: null })}>
                <LeadManagementContactModalContent handleClose={() => setUpsertLeadManagementContactModal({ open: false, id: null })} handleAdd={getLeadManagementContacts} entityId={upsertLeadManagementContactModal.id} />
            </Dialog>
        </AnimatedSpan>
    )
}
export default LeadManagementDetail
